import React from "react";
import {
  FormControlLabel,
  Switch,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Select,
  TextField,
  Input,
  Checkbox,
} from "@material-ui/core";
import LinkPreview from "@ashwamegh/react-link-preview";
import { Delete } from "@material-ui/icons";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik } from "formik";

import { setLoader } from "../../../redux/ducks/load.duck";
import * as contentsDUCK from "../../../redux/ducks/contents.duck";
import * as tagsDUCK from "../../../redux/ducks/tags.duck";
import { DropFiles, DropMultipleFiles } from "../../utils/DropFiles";
import { deleteContent } from "../../crud/api/content.crud";
import { Dropper } from "../../utils/DropNCrop";
import { setAlert } from "../../../redux/ducks/alert.duck";
import { previewLinkCard } from "../../utils/PreviewLinkCard";
import CustomEditor from "../../utils/CustomEditor";
import * as focusAreasDUCK from "../../../redux/ducks/focus_areas.duck.js";
import useContentDialogMaintenance from "./hooks/useContentDialogMaintenance.js";

const ContentsDialog = ({
  mode,
  setDialog,
  contentActions,
  settingLoader,
  setAlert,
  page,
  school,
}) => {
  const {
    content,
    moods,
    filteredCategories,
    filteredContributingFactors,
    filteredFocusAreas,
    filteredTags,
    permitedFiles,
    filterCategories,
    filterTags,
    filterFocusAreas,
    filterContributingFactors,
    is_disabled,
    create,
    update,
    loading,
    setLoading,
    getContentsx,
  } = useContentDialogMaintenance({ school, setDialog });
  const title = mode === "editing" ? "Edit Content" : "New Content";

  const deleteCont = (id) => {
    setAlert({
      title: "Delete Content",
      message: "Are you sure to permanently delete this Content?",
      btn_msg: "Delete Content",
      action: () =>
        deleteContent(id).then(() => {
          setDialog("close");
          getContentsx();
        }),
    });
  };

  return (
    <Dialog
      open={true}
      onClose={() => setDialog("close")}
      maxWidth="md"
      fullWidth
      id="content_dialog"
    >
      <DialogTitle>{title}</DialogTitle>
      <Formik
        initialValues={{
          ...content,
          notify_students: false,
          focus_areas_ids: content.focus_areas_ids
            ? content.focus_areas_ids
            : [],
          tags_ids: content.tags_ids ? content.tags_ids : [],
          categories_id: content.categories_id ? content.categories_id : [],
          contributing_factors_id: content.contributing_factors_id
            ? content.contributing_factors_id
            : [],
          moods_id: content.moods_id ? content.moods_id : [],
          is_pro_athlete: content.is_pro_athlete || false,
        }}
        enableReinitialize={true}
        validate={(values) => {
          const errors = {};
          if (!values.name) errors.name = "Required field";
          if (!values.content_type) errors.content_type = "Required field";
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          settingLoader(true);
          setLoading(true);
          values.content =
            values.content !== "" && values.content != null
              ? values.content
              : values.resource_url_slides;

          content.id ? update(values) : create(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={1}>
                {values.content_type !== "tip" ? (
                  <Grid container item spacing={2} xs={4}>
                    <Grid
                      item
                      xs={12}
                      style={{ position: "absolute", marginTop: -25 }}
                    >
                      <h6>Display image</h6>
                    </Grid>
                    <Grid item xs={12}>
                      <Dropper
                        setterFunction={setFieldValue}
                        file={values.image}
                        field={"image"}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <></>
                )}

                <Grid
                  container
                  item
                  spacing={2}
                  xs={values.content_type === "tip" ? 12 : 8}
                >
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      variant="outlined"
                      id="content_name_input_dialog"
                      name="name"
                      label="Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.name && errors.name}
                      error={Boolean(touched.name && errors.name)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      required
                      fullWidth
                      variant="outlined"
                      id="content_select_type_input_dialog"
                      label="Type of content"
                      name="content_type"
                      value={values.content_type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.content_type && errors.content_type}
                      error={Boolean(
                        touched.content_type && errors.content_type
                      )}
                    >
                      <MenuItem value="audio" id="content_type_audio">
                        Audio
                      </MenuItem>
                      <MenuItem value="video" id="content_type_video">
                        Video
                      </MenuItem>
                      <MenuItem value="document" id="content_type_document">
                        Document
                      </MenuItem>
                      <MenuItem value="html" id="content_type_html">
                        Text
                      </MenuItem>
                      <MenuItem value="image" id="content_type_link">
                        Image
                      </MenuItem>
                      <MenuItem value="tip" id="content_type_tip">
                        Tip
                      </MenuItem>
                    </TextField>
                  </Grid>

                  {values.content_type && (
                    <Grid item xs={12}>
                      {values.content_type === "html" ? (
                        <CustomEditor
                          value={values.content}
                          setFieldValue={setFieldValue}
                        />
                      ) : values.content_type === "link" ? (
                        <TextField
                          fullWidth
                          variant="outlined"
                          id="content_link_input_dialog"
                          label="Link"
                          name="content"
                          type="url"
                          value={values.content}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      ) : values.content_type === "image" ? (
                        values.content_type && (
                          <>
                            <Grid item xs={12}>
                              <h6 style={{ marginBottom: "10px" }}>
                                Add images
                              </h6>
                            </Grid>
                            <Grid item xs={12}>
                              <DropMultipleFiles
                                setterFunction={setFieldValue}
                                field="content"
                                files={
                                  values.resource_url_slides != null
                                    ? values.resource_url_slides
                                    : values.content
                                }
                                value={values.content}
                                type={permitedFiles(values.content_type)}
                              />
                            </Grid>
                          </>
                        )
                      ) : (
                        values.content_type && (
                          <>
                            <Grid item xs={12}>
                              <h6>Add content</h6>
                            </Grid>
                            <Grid item xs={12}>
                              <DropFiles
                                setterFunction={setFieldValue}
                                field="content"
                                value={values.content}
                                type={permitedFiles(values.content_type)}
                              />
                            </Grid>
                          </>
                        )
                      )}
                    </Grid>
                  )}
                  {values.content_type &&
                    values.content_type === "link" &&
                    values.content &&
                    (values.content.includes("http", 0) ||
                      values.content.includes("https", 0)) && (
                      <Grid item xs={12}>
                        <LinkPreview
                          url={values.content}
                          render={(data) =>
                            previewLinkCard(data, values.content)
                          }
                        />
                      </Grid>
                    )}
                  {values.content_type === "tip" ? (
                    <>
                      <Grid item xs={3} className="mt-2">
                        <Checkbox
                          required
                          id="is_pro_athlete"
                          name="is_pro_athlete"
                          checked={values.is_pro_athlete}
                          onChange={(e) => {
                            filterCategories(e.target.checked);
                            filterTags(e.target.checked);
                            filterFocusAreas(e.target.checked);
                            filterContributingFactors(e.target.checked);
                            setFieldValue("is_pro_athlete", e.target.checked);
                            setFieldValue("categories_id", []);
                            setFieldValue("tags_ids", []);
                            setFieldValue("focus_areas_ids", []);
                            setFieldValue("moods_id", []);
                            setFieldValue("contributing_factors_id", []);
                            handleChange(e);
                          }}
                        />
                        <span>Pro atlhete</span>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          fullWidth
                          variant="outlined"
                          id="content_description_input_dialog"
                          name="description_content"
                          label="Tip Text"
                          value={values.description_content}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={
                            touched.description_content &&
                            errors.description_content
                          }
                          error={Boolean(
                            touched.description_content &&
                              errors.description_content
                          )}
                        />
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        variant="outlined"
                        id="content_duration_input_dialog"
                        name="duration"
                        label="Duration"
                        value={values.duration}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.duration && errors.duration}
                        error={Boolean(touched.duration && errors.duration)}
                      />
                    </Grid>
                  )}
                </Grid>
                {values.content_type !== "tip" && (
                  <>
                    <Divider style={{ width: "100%" }} />
                    <Grid container item xs={12}>
                      <h6 style={{ marginTop: 10, marginBottom: 30 }}>
                        About The Author
                      </h6>
                    </Grid>
                    <Grid
                      container
                      item
                      spacing={2}
                      xs={4}
                      style={{ position: "relative" }}
                    >
                      <Grid
                        item
                        xs={12}
                        style={{ position: "absolute", marginTop: -25 }}
                      >
                        <h6>Logo</h6>
                      </Grid>
                      <Grid item xs={12}>
                        <Dropper
                          setterFunction={setFieldValue}
                          file={values.logo}
                          field={"logo"}
                        />
                      </Grid>
                    </Grid>

                    <Grid container item spacing={2} xs={8}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          fullWidth
                          variant="outlined"
                          id="content_author_name_input_dialog"
                          name="author_name"
                          label="Author name"
                          value={values.author_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={touched.author_name && errors.author_name}
                          error={Boolean(
                            touched.author_name && errors.author_name
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          fullWidth
                          variant="outlined"
                          id="content_partner_input_dialog"
                          name="content_partner"
                          label="Content Partner"
                          value={values.content_partner}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={
                            touched.content_partner && errors.content_partner
                          }
                          error={Boolean(
                            touched.content_partner && errors.content_partner
                          )}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          fullWidth
                          variant="outlined"
                          id="content_description_input_dialog"
                          name="description"
                          label="Description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={touched.description && errors.description}
                          error={Boolean(
                            touched.description && errors.description
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={3} className="mt-2">
                      <Checkbox
                        required
                        id="is_pro_athlete"
                        name="is_pro_athlete"
                        checked={values.is_pro_athlete || false}
                        onChange={(e) => {
                          filterCategories(e.target.checked);
                          filterTags(e.target.checked);
                          filterFocusAreas(e.target.checked);
                          filterContributingFactors(e.target.checked);
                          setFieldValue("is_pro_athlete", e.target.checked);
                          setFieldValue("categories_id", []);
                          setFieldValue("tags_ids", []);
                          setFieldValue("focus_areas_ids", []);
                          setFieldValue("moods_id", []);
                          setFieldValue("contributing_factors_id", []);

                          handleChange(e);
                        }}
                      />
                      <span>Pro atlhete</span>
                    </Grid>
                    {values.content_type !== "tip" && (
                      <>
                        <Grid container item xs={12}>
                          <Divider />
                          <h6 style={{ marginTop: 10 }}>Category *</h6>
                        </Grid>
                        <Grid container item xs={12}>
                          <Select
                            multiple
                            required
                            fullWidth
                            id="content_select_category_input_dialog"
                            label="Category"
                            name="categories_id"
                            value={values.categories_id}
                            input={<Input variant="outlined" />}
                            renderValue={(selected) =>
                              filteredCategories
                                .filter((x) => selected.includes(x.key))
                                .map((n) => {
                                  return n.name;
                                })
                                .join(",")
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              touched.categories_id && errors.categories_id
                            }
                            error={Boolean(
                              touched.categories_id && errors.categories_id
                            )}
                          >
                            {filteredCategories.map((fa) => (
                              <MenuItem key={fa.key} value={fa.key}>
                                {fa.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </>
                    )}
                    <Grid container item xs={12}>
                      <Divider />
                      <h6 style={{ marginTop: 10 }}>Tags</h6>
                    </Grid>
                    <Grid container item xs={12} style={{ overflow: "auto" }}>
                      <Select
                        multiple
                        required
                        fullWidth
                        id="content_select_tag_input_dialog"
                        label="Tag"
                        name="tags_ids"
                        value={values.tags_ids}
                        input={<Input variant="" />}
                        renderValue={(selected) =>
                          filteredTags
                            .filter((x) => selected.includes(x.id))
                            .map((n) => {
                              return n.name;
                            })
                            .join(",")
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.tags_ids && errors.tags_ids}
                        error={Boolean(touched.tags_ids && errors.tags_ids)}
                      >
                        {filteredTags.map((fa) => (
                          <MenuItem key={fa.id} value={fa.id}>
                            {fa.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid container item xs={12}>
                      <Divider />
                      <h6 style={{ marginTop: 10 }}>Focus Areas</h6>
                    </Grid>

                    <Grid container item xs={12}>
                      <Select
                        multiple
                        required
                        fullWidth
                        id="content_select_type_input_dialog"
                        label="Focus Areas"
                        name="focus_areas_ids"
                        value={values.focus_areas_ids}
                        input={<Input variant="outlined" />}
                        renderValue={(selected) =>
                          filteredFocusAreas
                            .filter((x) => selected.includes(x.id))
                            .map((n) => {
                              return n.name;
                            })
                            .join(",")
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.focus_areas_ids && errors.focus_areas_ids
                        }
                        error={Boolean(
                          touched.focus_areas_ids && errors.focus_areas_ids
                        )}
                      >
                        {filteredFocusAreas.map((fa) => (
                          <MenuItem key={fa.id} value={fa.id}>
                            {fa.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </>
                )}
                <Grid container item xs={12}>
                  <Divider />
                  <h6 style={{ marginTop: 10 }}>Mood</h6>
                </Grid>
                <Grid container item xs={12}>
                  <Select
                    multiple
                    required
                    fullWidth
                    id="content_select_mood_input_dialog"
                    label="Mood"
                    name="moods_id"
                    value={values.moods_id}
                    input={<Input variant="outlined" />}
                    renderValue={(selected) =>
                      moods
                        .filter((x) => selected.includes(x.key))
                        .map((n) => {
                          return n.name;
                        })
                        .join(",")
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.moods_id && errors.moods_id}
                    error={Boolean(touched.moods_id && errors.moods_id)}
                  >
                    {moods.map((fa) => (
                      <MenuItem key={fa.key} value={fa.key}>
                        {fa.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid container item xs={12}>
                  <Divider />
                  <h6 style={{ marginTop: 10 }}>Contributing Factors</h6>
                </Grid>
                <Grid container item xs={12}>
                  <Select
                    multiple
                    required
                    fullWidth
                    id="content_select_contributing_factors_id_input_dialog"
                    label="Contributing Factors"
                    name="contributing_factors_id"
                    value={values.contributing_factors_id}
                    input={<Input />}
                    renderValue={(selected) =>
                      filteredContributingFactors
                        .filter((x) => selected.includes(x.value))
                        .map((n) => {
                          return n.text;
                        })
                        .join(",")
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.contributing_factors_id &&
                      errors.contributing_factors_id
                    }
                    error={Boolean(
                      touched.contributing_factors_id &&
                        errors.contributing_factors_id
                    )}
                  >
                    {filteredContributingFactors.map((fa) => (
                      <MenuItem key={fa.value} value={fa.value}>
                        {fa.text}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {values.content_type !== "tip" && mode === "create" && (
                  <Grid container item xs={3} className="ml-0 mt-2">
                    <FormControlLabel
                      style={{ minWidth: 180 }}
                      className="ml-0 pl-0 text-left justify-content-end"
                      label="Notify Athletes"
                      labelPlacement="start"
                      control={
                        <Switch
                          id="content_notify_switch_dialog"
                          name="notify_students"
                          checked={values.notify_students}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions className={content.id && "justify-content-between"}>
              {content.id && (
                <button
                  id="content_delete_btn_dialog"
                  type="reset"
                  className="btn btn-danger"
                  onClick={() => deleteCont(content.id)}
                >
                  <Delete /> Delete Content
                </button>
              )}
              <div className="d-flex">
                <Button
                  id="content_cancel_btn_dialog"
                  onClick={() => setDialog("close")}
                  color="secondary"
                >
                  Cancel
                </Button>
                <button
                  type="submit"
                  id="content_submit_btn_dialog"
                  disabled={is_disabled(values)}
                  className="btn btn-primary btn-elevate kt-login__btn-primary d-flex"
                >
                  {mode === "editing" ? "Submit " : "Create"}
                  {loading && (
                    <CircularProgress
                      color="inherit"
                      size={18}
                      style={{ marginLeft: 10 }}
                    />
                  )}
                </button>
              </div>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

const mapStateToProps = (store) => {
  return {
    content: store.contents_.content,
    school: store.school.selected_school,
    focus_areas: store.focus_areas.focus_areas,
    tags: store.tags.tags,
  };
};

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
  contentActions: bindActionCreators(contentsDUCK.actions, dispatch),
  setAlert: bindActionCreators(setAlert, dispatch),
  focusAreasActions: bindActionCreators(focusAreasDUCK.actions, dispatch),
  tagsActions: bindActionCreators(tagsDUCK.actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentsDialog);
